"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SettingsVideoInput = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _metrics = require("@studio/metrics");
var _utils = require("../utils");
var _constants = require("@studio/constants");
var _underscore = require("underscore");
var _FormDropdown = require("../../FormDropdown");
var _Switch = require("../../Switch");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _chime = require("@studio/chime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var SettingsVideoInput = exports.SettingsVideoInput = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var meetingSession = _ref.meetingSession,
    showBlurredBackgroundSwitch = _ref.showBlurredBackgroundSwitch,
    userBackground = _ref.userBackground,
    onVideoInputChange = _ref.onVideoInputChange,
    setUserBackground = _ref.setUserBackground,
    transformedVideoInput = _ref.transformedVideoInput,
    selectedVideoInputId = _ref.selectedVideoInputId,
    onTransformedVideoInputChange = _ref.onTransformedVideoInputChange,
    isAudioPermissionDenied = _ref.isAudioPermissionDenied,
    backgroundUrl = _ref.backgroundUrl,
    _ref$setIsVideoChangi = _ref.setIsVideoChanging,
    setIsVideoChanging = _ref$setIsVideoChangi === void 0 ? function () {} : _ref$setIsVideoChangi,
    _ref$setIsVideoDiscon = _ref.setIsVideoDisconnected,
    setIsVideoDisconnected = _ref$setIsVideoDiscon === void 0 ? function () {} : _ref$setIsVideoDiscon;
  var _useBackgroundFilterP = (0, _metrics.useBackgroundFilterPageActionsApi)(),
    startAttendeeBackgroundFilterChangeLatency = _useBackgroundFilterP.startAttendeeBackgroundFilterChangeLatency,
    endAttendeeBackgroundFilterChangeLatency = _useBackgroundFilterP.endAttendeeBackgroundFilterChangeLatency;
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    videoDevices = _useState2[0],
    setVideoDevices = _useState2[1];
  (0, _chime.useAudioVideoDevice)({
    meetingSession: meetingSession,
    setDevices: setVideoDevices,
    onDeviceChanged: onVideoInputChange,
    selectedDeviceId: selectedVideoInputId,
    deviceType: _constants.VIDEO_INPUT,
    transformedVideoInput: transformedVideoInput
  });
  var _useCommonPageActions = (0, _metrics.useCommonPageActionsApi)(),
    cameraChanged = _useCommonPageActions.cameraChanged;
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isLoadingVirtualBackground = _useState4[0],
    setIsLoadingVirtualBackground = _useState4[1];
  var disableVideoInput = (videoDevices === null || videoDevices === void 0 ? void 0 : videoDevices.length) === 1 && videoDevices[0].value === '' || isLoadingVirtualBackground || isAudioPermissionDenied;
  var formattedVideoDevices = (0, _utils.formatDevicesArrayForDropdown)(videoDevices);
  var handleVideoInputChange = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(videoInputId, videoInputName) {
      var videoInput;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(videoInputId === selectedVideoInputId || !selectedVideoInputId)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            _context.prev = 2;
            setIsVideoChanging(true);
            if (userBackground !== _constants.BACKGROUND_OPTIONS.NONE) {
              startAttendeeBackgroundFilterChangeLatency({
                filterTypeBefore: userBackground,
                filterTypeAfter: userBackground
              });
            }
            setIsLoadingVirtualBackground(true);
            _context.next = 8;
            return (0, _chime.getVideoInput)(userBackground, transformedVideoInput, videoInputId, onTransformedVideoInputChange, userBackground === _constants.BACKGROUND_OPTIONS.CUSTOM ? backgroundUrl : '');
          case 8:
            videoInput = _context.sent;
            onVideoInputChange(videoInput);
            cameraChanged({
              cameraName: videoInputName
            });
            if (userBackground !== _constants.BACKGROUND_OPTIONS.NONE) {
              endAttendeeBackgroundFilterChangeLatency();
            }
            _context.next = 18;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](2);
            console.error('Error changing video input', _context.t0);
            endAttendeeBackgroundFilterChangeLatency({
              error: "Error changing video input : ".concat(_context.t0.message)
            });
          case 18:
            _context.prev = 18;
            setIsLoadingVirtualBackground(false);
            return _context.finish(18);
          case 21:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 14, 18, 21]]);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [selectedVideoInputId, userBackground, transformedVideoInput, onTransformedVideoInputChange, backgroundUrl]);
  var handleBlurBackgroundChange = (0, _react.useCallback)((0, _underscore.debounce)( /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(event) {
      var checked, option, videoInput;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            checked = event.target.checked;
            option = checked ? _constants.BACKGROUND_OPTIONS.NONE : _constants.BACKGROUND_OPTIONS.BLUR;
            _context2.prev = 2;
            setIsVideoChanging(true);
            startAttendeeBackgroundFilterChangeLatency({
              filterTypeBefore: userBackground,
              filterTypeAfter: option
            });
            setIsLoadingVirtualBackground(true);
            _context2.next = 8;
            return (0, _chime.getVideoInput)(option, transformedVideoInput, selectedVideoInputId, onTransformedVideoInputChange);
          case 8:
            videoInput = _context2.sent;
            onVideoInputChange(videoInput);
            setUserBackground(option);
            setIsLoadingVirtualBackground(false);
            endAttendeeBackgroundFilterChangeLatency();
            _context2.next = 19;
            break;
          case 15:
            _context2.prev = 15;
            _context2.t0 = _context2["catch"](2);
            console.error('Error changing background option', _context2.t0);
            endAttendeeBackgroundFilterChangeLatency({
              error: "Error changing background option : ".concat(_context2.t0.message)
            });
          case 19:
            _context2.prev = 19;
            setIsLoadingVirtualBackground(false);
            return _context2.finish(19);
          case 22:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 15, 19, 22]]);
    }));
    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }(), 500), [selectedVideoInputId, transformedVideoInput, onTransformedVideoInputChange]);

  // Handles fallback to default when USB or Bluetooth device disconnects PROD-222661
  (0, _react.useEffect)(function () {
    if (videoDevices.length === 0) {
      onVideoInputChange(null);
      return;
    }
    var deviceConnected = videoDevices.some(function (option) {
      return option.deviceId === selectedVideoInputId;
    });
    if (!deviceConnected) {
      setIsVideoDisconnected(true);
      handleVideoInputChange(videoDevices[0].deviceId, videoDevices[0].label);
    }
  }, [handleVideoInputChange, selectedVideoInputId, videoDevices]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_FormDropdown.FormDropdown, {
    labelText: "Select Camera",
    "data-testid": "selectCamera",
    selected: selectedVideoInputId,
    options: formattedVideoDevices,
    id: "selectCamera",
    onChange: handleVideoInputChange,
    disabled: disableVideoInput,
    className: "mb-0"
  }), showBlurredBackgroundSwitch && /*#__PURE__*/_react["default"].createElement(_Switch.Switch, {
    className: "pt-1",
    labelText: "Blur background",
    id: "blurBackground",
    "data-testid": "blurBackground",
    disabled: disableVideoInput,
    checked: userBackground === _constants.BACKGROUND_OPTIONS.BLUR,
    "data-dd-action-name": "Background option switched to ".concat(userBackground === _constants.BACKGROUND_OPTIONS.BLUR ? _constants.BACKGROUND_OPTIONS.NONE : _constants.BACKGROUND_OPTIONS.BLUR),
    onChange: handleBlurBackgroundChange
  }));
});
SettingsVideoInput.propTypes = {
  meetingSession: _propTypes["default"].object,
  showBlurredBackgroundSwitch: _propTypes["default"].bool,
  userBackground: _propTypes["default"].string,
  onVideoInputChange: _propTypes["default"].func,
  setUserBackground: _propTypes["default"].func,
  transformedVideoInput: _propTypes["default"].object,
  selectedVideoInputId: _propTypes["default"].string,
  onTransformedVideoInputChange: _propTypes["default"].func,
  isAudioPermissionDenied: _propTypes["default"].bool,
  backgroundUrl: _propTypes["default"].string,
  setIsVideoChanging: _propTypes["default"].func,
  setIsVideoDisconnected: _propTypes["default"].func
};